/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
  'use strict'

  const app = angular.module('admin.login', ['gettext', 'vvCommon'])

  app.controller("FBLoginController", function($rootScope, $scope, $window, $http, vv, vvPopup) {
    $rootScope.fbInitPromise.then(function(fb_auth_info) {
      console.log('authed fb id', fb_auth_info.id, fb_auth_info.name)
      return $http.post('/admin/data/auth/fb', {})
    }).then(function(resp) {
      let fb_id = resp.data.fb_id
      let two_factor_activated = resp.data.two_factor_activated
      if (two_factor_activated !== 'Y') {
        $window.location.replace(vv.getVvMetaData('return_url'));
        var returnUrl = vv.getVvMetaData('return_url');
        if (returnUrl == '0') {
          try {
            $window.opener.loginCallback();
          } catch (e) {
          }
          $window.close();
        } else {
          $window.location.replace(returnUrl);
        }
      } else {
        console.log('fb_login with 2fa')
        vvPopup.openUrl('/admin/admin_user/2fa_authentication.html?_hv=763717d', {
          'fb_id': resp.data.fb_id
        });
      }
    });
  });

  app.controller("LoginController", function($rootScope, $scope, $http, $window, vv, gettextCatalog, vvPopup, $timeout) {
    $scope.form = {
      'email': '',
      'password': ''
    };

    // $scope.showFBLogin = $rootScope.vvSiteRegion != 'cn' ||
    //   location.host.match('cn\.([^.]+\.)?vonvon\.me(:[0-9]+)?$') != null ||
    //   location.host.match('cn\.([^.]+\.)?fb\.vonvon\.net(:[0-9]+)?$') != null
    // ;
    $scope.init = function() {
      let two_factor_authentication_required = vv.getVvMetaData('2fa_authentication_required');
      if (two_factor_authentication_required) {
        $timeout(function() {
          vvPopup.openUrl('/admin/admin_user/2fa_authentication.html?_hv=763717d', {
            'fb_id': 'slack:' + vv.getVvMetaData('unauthorized_slack_id')
          });
        }, 1000);
      }
    };

    $scope.$watch('user', function() {
      if ($rootScope.user != null) {
        $window.location.replace(vv.getVvMetaData('return_url'));
        var returnUrl = vv.getVvMetaData('return_url');
        if (returnUrl == '0') {
          try { $window.opener.loginCallback(); } catch (e) {}
          $window.close();
        } else {
          $window.location.replace(returnUrl);
        }
      }
    });

    $scope.login = function() {
      $http.post('/admin/data/auth/login.json', $scope.form).then(function(resp) {
        let two_factor_activated = resp.data.two_factor_activated
        if (two_factor_activated !== 'Y') {
          var returnUrl = vv.getVvMetaData('return_url');
          if (returnUrl == '0') {
            try {
              $window.opener.loginCallback();
            } catch (e) {
            }
            $window.close();
          } else {
            $window.location.replace(returnUrl);
          }
        } else {
          vvPopup.openUrl('/admin/admin_user/2fa_authentication.html?_hv=763717d', {
            'fb_id': resp.data.fb_id
          });
        }
      }, function(resp) {
        // log error
        alert(gettextCatalog.getString('로그인에 실패했습니다.'));
      });
    };

    $scope.closeLayer = function () {
      $scope.showLayer = true
      vvPopup.close()
      let returnUrl = vv.getVvMetaData('return_url');
      if (!$rootScope.two_factor_logged_in) {
        return
      }
      if (returnUrl == '0') {
        try { $window.opener.loginCallback(); } catch (e) {}
        $window.close();
      } else {
        $window.location.replace(returnUrl);
      }
    }

    $scope.init();
  });

  app.controller("TwoFactorLoginController", function($rootScope, $scope, $window, $http, gettextCatalog) {
    $scope.login = function() {
      angular.extend($scope.form, {
        'fb_id': $scope.fb_id
      })
      $http.post('/admin/data/auth/2fa_login', $scope.form).then(function(resp) {
        $rootScope.two_factor_logged_in = true
        $scope.closeLayer()
      }, function(resp) {
        // log error
        alert(gettextCatalog.getString('로그인에 실패했습니다.'));
      });
    };
    $scope.cancel = function() {
      $scope.closeLayer();
    }
  });
})();

